import * as React from 'react';
import styled from 'styled-components';
import { Card, Row, Col } from './index';
import * as Common from '../common';

const TotalColumn = styled(Col)`
  text-align: right;
`;

const Divider = styled.div`
  border-top: 3px double #8c8b8b;
  margin: 1em 0;
`;

interface Props {
  loading: boolean;
  recurringCost: string | React.ReactElement<any>;
  fixedCost: string | React.ReactElement<any>;
  totalCost: string | React.ReactElement<any>;
  showRecurringCostLine: boolean;
  showFixedCostLine: boolean;
  lineItemTextRecurring: string | React.ReactElement<any>;
  lineItemTextNonRecurring: string | React.ReactElement<any>;
  totalCostText: string | React.ReactElement<any>;
}

export const TotalCost: React.SFC<Props> = props => (
  <Card loading={props.loading} bordered>
    {props.showRecurringCostLine && (
      <Row>
        <Col span={18}>
          <Common.H3>{props.lineItemTextRecurring}</Common.H3>
        </Col>
        <TotalColumn span={6}>
          <Common.H3>{props.recurringCost}</Common.H3>
        </TotalColumn>
      </Row>
    )}
    {props.showFixedCostLine && (
      <Row>
        <Col span={18}>
          <Common.H3>{props.lineItemTextNonRecurring}</Common.H3>
        </Col>
        <TotalColumn span={6}>
          <Common.H3>{props.fixedCost}</Common.H3>
        </TotalColumn>
      </Row>
    )}

    <Divider />

    <Row>
      <Col span={12}>
        <Common.H3>{props.totalCostText}</Common.H3>
      </Col>
      <TotalColumn span={12}>
        <Common.H2>{props.totalCost}</Common.H2>
      </TotalColumn>
    </Row>

    <Divider />
  </Card>
);



// WEBPACK FOOTER //
// ./app/components/antd/TotalCost.tsx